import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import pepsicoLogo from "./../../assets/svgs/pepLogoDashboard.svg";
import styles from "./Header.module.css";
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  headDescription: string;
}


const HeaderContainer = styled(Box)({
  position: 'sticky',
  top: '0',
  width: '100%',
  zIndex: '1000', // Ensure it stays above other content
  backgroundColor: '#0047ba',
  boxSizing: 'border-box',
  minHeight: '48px',
  display: 'flex',
  alignItems: 'center',
  color: 'white',
  margin: '0 auto',
  padding: '0 8px',
  overflowX: 'hidden',
});

// const Logo = styled('img')({
//   height: '40px',
//   marginRight: '20px',
// });

const Header: React.FC<HeaderProps> = ({ headDescription }) =>  {

  const navigate = useNavigate();

  const navigateToHome = () => {
    navigate("/Inbound-Automation")
  }

  return (
    <HeaderContainer
  sx={{
    flexDirection: { xs: 'column', sm: 'row' }, // Stack items vertically on mobile
    alignItems: { xs: 'flex-start', sm: 'center' }, // Align items properly on mobile
    padding: { xs: '8px', sm: '0 8px' }, // Add padding for mobile devices
  }}
>
  <span className={styles.pepsiLogoCls}>
    <Box
      component="img"
      src={pepsicoLogo}
      alt="PepsiCo Logo"
      className={styles.peplogo}
      onClick={navigateToHome}
      sx={{
        height: { xs: '20px', sm: '25px', md: '35px' }, // Responsive sizes
        width: 'auto',
      }}
    />
  </span>
  <Typography
    variant="h6"
    sx={{
      fontFamily: 'Helvetica Neue',
      fontSize: { xs: '12px', sm: '16px', md: '22px' }, // Responsive font size
      fontWeight: { xs: 300, sm: 400, md: 700 }, // Responsive font weight
      textAlign: { xs: 'left', sm: 'center' }, // Align text properly on mobile
      width: '100%',
      margin: { xs: '8px 0 0 0', sm: '0 80px 0 0', md: '0 160px 0 0' }, // Adjust margin for mobile
      whiteSpace: 'normal', // Allow text to wrap
      wordWrap: 'break-word', // Break long words if necessary
    }}
    gutterBottom
  >
    {headDescription}
  </Typography>
</HeaderContainer>
  );
};

export default Header;